import React, { useState, useEffect, useMemo, useCallback } from "react";
import {
  Box,
  Container,
  Grid,
  Paper,
  Typography,
  // useTheme,
} from "@mui/material";
import { CameraAlt as CameraIcon } from "@mui/icons-material";
import Dropdown from "react-bootstrap/Dropdown";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./live.css";
import "./button.css";
import axios from "axios";
import CameraFeed from "./CameraFeed";
import LiveEvents from "./LiveEvents";
import { useDispatch } from "react-redux";
import { useParams, withRouter } from "react-router-dom";
import { backend_url } from "../App";
import MiniMap from "./MiniMap";
import { getOrganization } from "../features/organization/organizationSlice";

function LiveView() {
  const dispatch = useDispatch();
  const { id } = useParams();
  // const theme = useTheme();

  const [selectedEventForCone, setSelectedEventForCone] = useState(null);
  const [view, setView] = useState("camera");
  const [camera, setCamera] = useState({
    cam: "",
    link: "",
    id: 0,
    eventId: "",
  });

  // const date = new Date().toLocaleDateString("en-US", {
  //   month: "long",
  //   day: "numeric",
  //   year: "numeric",
  // });
  const [setCurrentTime] = useState("");

  const [tilt, setTilt] = useState(0);
  const [pan, setPan] = useState(0);
  const [zoom, setZoom] = useState(0);
  const [setMinTilt] = useState(0);
  const [setMinPan] = useState(0);
  const [setMinZoom] = useState(0);
  const [setMaxTilt] = useState(90);
  const [setMaxPan] = useState(360);
  const [setMaxZoom] = useState(100);
  const [live, setLive] = useState(true);
  const [liveStream, setLiveStream] = useState("");
  const [imageUrls, setImageUrls] = useState([]);
  const [towers, setTowers] = useState(null);
  const [preset, setPreset] = useState(null);
  const [setDes] = useState("");
  const [setDes1] = useState("");
  const [setDes2] = useState("");
  const [setAirTemp] = useState("");
  const [setAirHumidity] = useState("");

  useEffect(() => {
    dispatch(getOrganization());
  }, [dispatch]);

  useEffect(() => {
    if (id === "3") {
      setLive(true);
    }
  }, [id]);

  const config = useMemo(
    () => ({
      headers: {
        Authorization: `Token ${localStorage.getItem("token")}`,
      },
    }),
    [],
  );

  // Fetch camera data
  useEffect(() => {
    const fetchCameras = async () => {
      try {
        const response = await fetch(`${backend_url}/core/api/camera/`, config);
        const actualData = await response.json();
        setTowers(actualData.results);

        const tempId = Number(id);
        const foundObject = actualData.results.find((obj) => obj.id === tempId);
        if (foundObject) {
          setCamera({
            cam: foundObject.description,
            link: "",
            id: foundObject.id,
          });
          setLiveStream(foundObject.live_stream_url);
        }
      } catch (err) {
        console.error(err);
        setTowers(null);
      }
    };
    fetchCameras();
  }, [id, config]);

  // Fetch preset data
  useEffect(() => {
    const fetchPreset = async () => {
      try {
        const response = await fetch(
          `${backend_url}/core/api/preset/?camera_id=${id}`,
          config,
        );
        const actualData = await response.json();
        setPreset(actualData.results);

        actualData.results.forEach((obj) => {
          if (obj.name === "Default") {
            setPan(obj.pan_default);
            setMinPan(obj.pan_min);
            setMaxPan(obj.pan_max);
            setTilt(obj.tilt_default);
            setMinTilt(obj.tilt_min);
            setMaxTilt(obj.tilt_max);
            setZoom(obj.zoom_default);
            setMinZoom(obj.zoom_min);
            setMaxZoom(obj.zoom_max);
          }
          if (obj.name === "Preset 1") setDes(obj.description);
          if (obj.name === "Preset 2") setDes1(obj.description);
          if (obj.name === "Preset 3") setDes2(obj.description);
        });
      } catch (err) {
        console.error(err);
        setPreset(null);
      }
    };
    fetchPreset();
  }, [
    id,
    config,
    setDes,
    setDes1,
    setDes2,
    setMaxPan,
    setMaxTilt,
    setMaxZoom,
    setMinPan,
    setMinTilt,
    setMinZoom,
  ]);

  const loadGifFrames = useCallback(
    async (uuid, url = null) => {
      try {
        const gifUrl = url || `${backend_url}/core/api/image/?event=${uuid}`;
        const response = await fetch(gifUrl, config);
        if (!response.ok)
          throw new Error(
            `Failed to fetch GIF frames. Status: ${response.status}`,
          );

        const data = await response.json();
        const imageUrlsList = data.results.map((item) => {
          return item.file.includes("http://127.0.0.1:8000")
            ? item.file.replace(
                "http://127.0.0.1:8000",
                "https://api.forestwatch.org.pk",
              )
            : item.file;
        });
        setImageUrls((prev) => [...prev, ...imageUrlsList]);

        if (data.next !== null) {
          await loadGifFrames(uuid, data.next);
        }
      } catch (error) {
        console.error("Error loading GIF frames:", error);
      }
    },
    [config],
  );

  const eventClick = useCallback(
    (item) => {
      console.log("inside events", item);
      setCamera({
        cam: item.camera_name,
        link: item.file,
        id: item.id,
        eventId: item.uuid,
      });
      setSelectedEventForCone(item);

      if (item.uuid !== "") {
        setImageUrls([]);
        loadGifFrames(item.uuid);
      }
    },
    [loadGifFrames],
  );

  // Fetch weather data
  useEffect(() => {
    const fetchData = async () => {
      try {
        let deviceid;
        if (id === "3") deviceid = "8a86c4b0-3cb1-11ee-9dc2-07b8268a3068";
        else if (id === "5") deviceid = "c721d8c0-3a21-11ee-9dc2-07b8268a3068";
        else if (id === "6") deviceid = "9c4c6f10-30db-11ee-9dc2-07b8268a3068";
        else if (id === "7") deviceid = "9e6f1ab0-3a20-11ee-9dc2-07b8268a3068";
        else return;

        const token =
          "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJtdWhhbW1hZF93YXFhckBsdW1zLmVkdS5wayIsInVzZXJJZCI6ImNmMTgzMTYwLWYzNzAtMTFlZS05Mzc4LTIxNTVjZjA1NzBmOCIsInNjb3BlcyI6WyJDVVNUT01FUl9VU0VSIl0sInNlc3Npb25JZCI6ImYxNzA0NTJkLThlMTYtNDgwZC1hOWU4LTI4NzgyZGY5YmJiMiIsImlzcyI6InRoaW5nc2JvYXJkLmlvIiwiaWF0IjoxNzM0Mjk0NjQ2LCJleHAiOjE3NDIwNzA2NDYsImZpcnN0TmFtZSI6Ik11aGFtbWFkIiwibGFzdE5hbWUiOiJXYXFhciIsImVuYWJsZWQiOnRydWUsImlzUHVibGljIjpmYWxzZSwidGVuYW50SWQiOiI2YWFmMzZlMC0yZDUyLTExZWUtODM0OC0yMzc4NjQ5MWJkY2IiLCJjdXN0b21lcklkIjoiMjE1YTU1ZjAtODIzNS0xMWVlLWI2ZWEtOWQ2MDkwMzkwZjFiIn0._7a63CodyjvcMzqsZquypEw6r4iLSbr1AYASqc2Ouk_EqziCOQqw8fcrR1U69jLjsEw2Q8qNECT2_OAYIW-2Eg";

        const response = await axios.get(
          `http://icarus.lums.edu.pk/api/plugins/telemetry/DEVICE/${deviceid}/values/timeseries`,
          {
            headers: {
              "Content-Type": "application/json",
              "X-Authorization": token,
            },
            params: {
              keys: "Air_Temperature,Air_Humidity",
              startTs: new Date().getTime() - 10 * 60 * 1000,
              endTs: new Date().getTime(),
            },
          },
        );

        const { data } = response;
        if (data.Air_Temperature && data.Air_Temperature[0]) {
          const timestampMs = data.Air_Temperature[0].ts;
          const dateObj = new Date(timestampMs);
          const hours = dateObj.getHours().toString().padStart(2, "0");
          const minutes = dateObj.getMinutes().toString().padStart(2, "0");
          const seconds = dateObj.getSeconds().toString().padStart(2, "0");

          setCurrentTime(`${hours}:${minutes}:${seconds}`);
          setAirTemp(data.Air_Temperature[0].value);
          setAirHumidity(data.Air_Humidity[0].value);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    const intervalId = setInterval(fetchData, 60000);
    return () => clearInterval(intervalId);
  }, [id, setAirHumidity, setAirTemp, setCurrentTime]);

  // const HandleSubmit = async () => {
  //   try {
  //     const nam = camera.cam.replace(" ", "-");
  //     await fetch(`${backend_url}/core/api/camera/ptzControls/`, {
  //       method: "POST",
  //       body: JSON.stringify({ pan, tilt, zoom, camera: nam }),
  //       headers: {
  //         "Content-type": "application/json",
  //         Authorization: `Token ${localStorage.getItem("token")}`,
  //       },
  //     });
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  // const handleRefresh = () => {
  //   if (preset && preset.length > 0) {
  //     const defaultPreset = preset.find((obj) => obj.name === "Default");
  //     if (defaultPreset) {
  //       setPan(defaultPreset.pan_default);
  //       setMinPan(defaultPreset.pan_min);
  //       setMaxPan(defaultPreset.pan_max);
  //       setTilt(defaultPreset.tilt_default);
  //       setMinTilt(defaultPreset.tilt_min);
  //       setMaxTilt(defaultPreset.tilt_max);
  //       setZoom(defaultPreset.zoom_default);
  //       setMinZoom(defaultPreset.zoom_min);
  //       setMaxZoom(defaultPreset.zoom_max);
  //     }
  //   }
  // };

  // const changePreset = (presetName) => {
  //   if (preset && preset.length > 0) {
  //     const selected = preset.find((obj) => obj.name === presetName);
  //     if (selected) {
  //       setPan(selected.pan_default);
  //       setMinPan(selected.pan_min);
  //       setMaxPan(selected.pan_max);
  //       setTilt(selected.tilt_default);
  //       setMinTilt(selected.tilt_min);
  //       setMaxTilt(selected.tilt_max);
  //       setZoom(selected.zoom_default);
  //       setMinZoom(selected.zoom_min);
  //       setMaxZoom(selected.zoom_max);
  //     }
  //   }
  // };

  // Memoize MiniMap
  const miniMapComponent = useMemo(
    () => (
      <MiniMap
        camId={id}
        live={live}
        isSidebar={false}
        selectedEvent={selectedEventForCone}
      />
    ),
    [id, live, selectedEventForCone],
  );

  // Control button style
  // const controlButtonStyle = {
  //   width: 48,
  //   height: 48,
  //   backgroundColor: alpha(theme.palette.primary.main, 0.1),
  //   borderRadius: 2,
  //   transition: "all 0.2s ease",
  //   "&:hover": {
  //     backgroundColor: alpha(theme.palette.primary.main, 0.2),
  //     transform: "scale(1.05)",
  //   },
  // };

  // const valueDisplayStyle = {
  //   minWidth: 50,
  //   textAlign: "center",
  //   fontWeight: 600,
  //   fontSize: 16,
  //   color: theme.palette.primary.main,
  // };

  return (
    <Box sx={{ minHeight: "93vh", bgcolor: "#f5f5f5", pt: 2, mt: 7 }}>
      <Container maxWidth="xl">
        {/* Top Bar with Camera Selector */}
        <Paper
          elevation={0}
          sx={{
            p: 2,
            mb: 2,
            borderRadius: 3,
            background: "linear-gradient(135deg, #454545 0%, #2d2d2d 100%)",
            color: "white",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 2,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <CameraIcon sx={{ fontSize: 32 }} />
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Event Analysis
              </Typography>
              {/* <Chip
                label={camera.cam || "Select Camera"}
                size="small"
                sx={{
                  bgcolor: alpha(theme.palette.warning.main, 0.2),
                  color: theme.palette.warning.main,
                  fontWeight: 600,
                }}
              /> */}
            </Box>

            {/* Camera Dropdown */}

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Dropdown>
                <Dropdown.Toggle
                  style={{
                    background:
                      "linear-gradient(135deg, #454545 0%, rgba(129, 129, 129, 0.95) 100%)",
                    color: "rgb(0, 0, 0)",
                    border: "none",
                    fontWeight: "700",
                    borderRadius: 8,
                    padding: "8px 20px",
                  }}
                >
                  {camera.cam || "Select Camera"}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {towers &&
                    towers.map(
                      (item) =>
                        item.live && (
                          <Dropdown.Item
                            key={item.id}
                            href={`/live/${item.id}`}
                            onClick={() =>
                              setCamera({
                                cam: item.name,
                                link: "",
                                id: item.id,
                              })
                            }
                          >
                            {item.description}
                          </Dropdown.Item>
                        ),
                    )}
                </Dropdown.Menu>
              </Dropdown>
              {/* {air_humidity && air_temp && (
                <>
                  <Box
                    sx={{
                      width: 1,
                      height: 20,
                      bgcolor: "rgba(255,255,255,0.2)",
                      mx: 1,
                    }}
                  />
                  <Tooltip title="Temperature">
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                    >
                      <ThermostatIcon sx={{ fontSize: 16 }} />
                      <Typography variant="body2">{air_temp}°C</Typography>
                    </Box>
                  </Tooltip>
                  <Tooltip title="Humidity">
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                    >
                      <OpacityIcon sx={{ fontSize: 16 }} />
                      <Typography variant="body2">{air_humidity}%</Typography>
                    </Box>
                  </Tooltip>
                </>
              )} */}
            </Box>
          </Box>
        </Paper>

        {/* Main Content Grid */}
        <Grid container spacing={3}>
          {/* Left Column - PTZ Controls or MiniMap */}
          <Grid item xs={12} md={4} lg={3}>
            <Paper
              elevation={0}
              sx={{
                borderRadius: 3,
                overflow: "hidden",
                bgcolor: "white",
              }}
            >
              {/* {live ? (
                <Box sx={{ p: 3 }}>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 600, mb: 2, textAlign: "center" }}
                  >
                    PTZ Controls
                  </Typography>

                  <Stack
                    direction="row"
                    spacing={1}
                    justifyContent="center"
                    sx={{ mb: 3 }}
                  >
                    <Tooltip title={des}>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => changePreset("Preset 1")}
                        disabled={des === ""}
                        sx={{ borderRadius: 2, textTransform: "none" }}
                      >
                        Preset 1
                      </Button>
                    </Tooltip>
                    <Tooltip title={des1}>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => changePreset("Preset 2")}
                        disabled={des1 === ""}
                        sx={{ borderRadius: 2, textTransform: "none" }}
                      >
                        Preset 2
                      </Button>
                    </Tooltip>
                    <Tooltip title={des2}>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => changePreset("Preset 3")}
                        disabled={des2 === ""}
                        sx={{ borderRadius: 2, textTransform: "none" }}
                      >
                        Preset 3
                      </Button>
                    </Tooltip>
                  </Stack>

                  <Divider sx={{ my: 2 }} />

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-around",
                      mb: 2,
                    }}
                  >
                    <Typography variant="caption" color="text.secondary">
                      Pan
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Tilt
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Zoom
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Tooltip title="Pan Left">
                        <IconButton
                          sx={controlButtonStyle}
                          onClick={() => {
                            if (pan !== minpan && pan - 10 >= minpan)
                              setPan(pan - 10);
                          }}
                        >
                          <ArrowBackIcon />
                        </IconButton>
                      </Tooltip>
                      <Typography sx={valueDisplayStyle}>{pan}</Typography>
                      <Tooltip title="Pan Right">
                        <IconButton
                          sx={controlButtonStyle}
                          onClick={() => {
                            if (pan !== maxpan && pan + 10 <= maxpan)
                              setPan(pan + 10);
                          }}
                        >
                          <ArrowForwardIcon />
                        </IconButton>
                      </Tooltip>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 0.5,
                      }}
                    >
                      <Tooltip title="Tilt Up">
                        <IconButton
                          sx={{ ...controlButtonStyle, width: 40, height: 40 }}
                          onClick={() => {
                            if (tilt !== maxtilt && tilt + 5 <= maxtilt)
                              setTilt(tilt + 5);
                          }}
                        >
                          <ArrowUpwardIcon />
                        </IconButton>
                      </Tooltip>
                      <Typography sx={valueDisplayStyle}>{tilt}</Typography>
                      <Tooltip title="Tilt Down">
                        <IconButton
                          sx={{ ...controlButtonStyle, width: 40, height: 40 }}
                          onClick={() => {
                            if (tilt !== mintilt && tilt - 5 >= mintilt)
                              setTilt(tilt - 5);
                          }}
                        >
                          <ArrowDownwardIcon />
                        </IconButton>
                      </Tooltip>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Tooltip title="Zoom Out">
                        <IconButton
                          sx={controlButtonStyle}
                          onClick={() => {
                            if (zoom !== minzoom && zoom - 10 >= minzoom)
                              setZoom(zoom - 10);
                          }}
                        >
                          <ZoomOutIcon />
                        </IconButton>
                      </Tooltip>
                      <Typography sx={valueDisplayStyle}>{zoom}</Typography>
                      <Tooltip title="Zoom In">
                        <IconButton
                          sx={controlButtonStyle}
                          onClick={() => {
                            if (zoom !== maxzoom && zoom + 10 <= maxzoom)
                              setZoom(zoom + 10);
                          }}
                        >
                          <ZoomInIcon />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Box>

                  <Divider sx={{ my: 3 }} />

                  <Stack direction="row" spacing={2} justifyContent="center">
                    <Tooltip title="Reset to Default">
                      <Button
                        variant="contained"
                        color="warning"
                        startIcon={<CachedIcon />}
                        onClick={handleRefresh}
                        sx={{ borderRadius: 2, textTransform: "none" }}
                      >
                        Reset
                      </Button>
                    </Tooltip>
                    <Tooltip title="Apply Settings">
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<CheckCircleIcon />}
                        onClick={HandleSubmit}
                        sx={{ borderRadius: 2, textTransform: "none" }}
                      >
                        Apply
                      </Button>
                    </Tooltip>
                  </Stack>
                </Box>
              ) : ( */}
              <Box sx={{ p: 0 }}>{miniMapComponent}</Box>
              {/* )} */}
            </Paper>
          </Grid>

          {/* Center Column - Camera Feed */}
          <Grid item xs={12} md={8} lg={6}>
            <Paper
              elevation={0}
              sx={{
                borderRadius: 3,
                overflow: "hidden",
                bgcolor: "#000",
                minHeight: 500,
              }}
            >
              <CameraFeed
                cameraId={camera}
                view={view}
                live={live}
                changeLive={setLive}
                liveStream={liveStream}
                imageUrls={imageUrls}
                pan={pan}
                zoom={zoom}
                tilt={tilt}
              />
            </Paper>
          </Grid>

          {/* Right Column - Events */}
          <Grid item xs={12} lg={3}>
            <Paper
              elevation={0}
              sx={{
                borderRadius: 3,
                overflow: "hidden",
                height: "100%",
                maxHeight: 600,
              }}
            >
              <LiveEvents
                eventClick={eventClick}
                cam_id={id}
                setRow={() => {}}
                setView={setView}
              />
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default withRouter(LiveView);
